import React, { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModuleNav, ModuleNavItem } from '../../contexts/ModuleNavContext';
import { useMenu } from '../../auth/useMenu';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';

const ALL_CONSUMABLES_NAV_ITEMS: ModuleNavItem[] = [
  { to: '/consumables/catalog',          labelKey: 'consumables.catalog.title',         subject: 'consumables:catalog' },
  { to: '/consumables/stock-levels',     labelKey: 'consumables.stockLevels.title',     subject: 'consumables:inventory' },
  { to: '/consumables/stock-movements',  labelKey: 'consumables.stockMovements.title',  subject: 'consumables:inventory' },
  { to: '/consumables/procurement',      labelKey: 'consumables.procurement.title',     subject: 'consumables:procurement' },
  { to: '/consumables/unit-review',      labelKey: 'consumables.unitReview.title',      subject: 'consumables:unitReview' },
];

const ConsumablesLayout: React.FC = () => {
  const { t } = useTranslation();
  const { setModule } = useModuleNav();

  const hasCatalog     = useMenu('consumables:catalog');
  const hasInventory   = useMenu('consumables:inventory');
  const hasProcurement = useMenu('consumables:procurement');
  const hasUnitReview  = useMenu('consumables:unitReview');

  const filteredItems = useMemo(() => {
    const menuMap: Record<string, boolean> = {
      'consumables:catalog':     hasCatalog,
      'consumables:inventory':   hasInventory,
      'consumables:procurement': hasProcurement,
      'consumables:unitReview':  hasUnitReview,
    };
    return ALL_CONSUMABLES_NAV_ITEMS.filter(item => {
      if (!item.subject) return true;
      return menuMap[item.subject] === true;
    });
  }, [hasCatalog, hasInventory, hasProcurement, hasUnitReview]);

  useEffect(() => {
    setModule(t('consumables.title'), filteredItems);
    return () => setModule(null, null);
  }, [setModule, t, filteredItems]);

  useBreadcrumb([
    { label: 'Citrus Synch', to: '/' },
    { label: t('consumables.title'), to: '/consumables/catalog' },
  ]);

  return (
    <div data-testid="consumables-layout">
      <Outlet />
    </div>
  );
};

export default ConsumablesLayout;
